import * as HeroIconsSolid from "@heroicons/react/24/solid";
import * as HeroIconsOutline from "@heroicons/react/24/outline";

interface Props {
  name:
    | keyof typeof HeroIconsSolid
    | keyof typeof HeroIconsOutline
    | (string & Record<never, never>);
  className?: string;
  onClick?: React.MouseEventHandler<HTMLSpanElement> | (() => void);
  variant?: "solid" | "outline";
  title?: string;
  testId?: string;
}

function GetHeroIcon({
  name,
  className,
  onClick,
  variant = "solid",
  title,
  testId
}: Props) {
  const SelectedIcon =
    variant === "solid"
      ? HeroIconsSolid[name as keyof typeof HeroIconsSolid]
      : HeroIconsOutline[name as keyof typeof HeroIconsOutline];
  if (!SelectedIcon) {
    console.warn(
      "%cCUSTOM WARNING: %c.SelectedIcon not found for name: " + name,
      "color: orange; font-weight: bold;",
      "color: red; background: yellow;"
    );
    return null;
  }
  return (
    <span
      data-testid={testId}
      className={`dark:text-white transition-transform duration-300 ease-in-out transform ${
        name === "MinusIcon" ? "rotate-180" : "rotate-0"
      }`}
      onClick={(e) => {
        if (onClick) onClick(e);
      }}
    >
      <SelectedIcon className={className} title={title} />
    </span>
  );
}

export default GetHeroIcon;
